import { createContext, useContext, useReducer  } from 'react'

const FormContext = createContext()

const useForm = () => {
    const context = useContext(FormContext)

    if (context === undefined) throw new Error('useForm must be used within a FormProvider')

    return context
}

const FormProvider = ({ children }) => {
    const reducer = (state, { name, payload }) => {
        return { ...state, [name]: payload }
    }

    const [$state, dispatch] = useReducer(reducer, {})

    const save = (name, payload) => dispatch({ name, payload })

    return (
        <FormContext.Provider value={{ $state, save }}>
            {children}
        </FormContext.Provider>
    )
}

export { useForm, FormProvider }